import { useSubscribe } from "~/components/blackFriday/hooks/Subscribe"
import Icon from "~/components/ui/Icon"

interface Props {
    title?: string
}

export default function SubscribeForm({ title }: Props) {
    const { result, handleSubscribe, isInvalid, getErrorMessage, removeErrorOnInput } =
        useSubscribe()

    if (result.value?.success) {
        return (
            <div className='h-full grid justify-items-center content-center gap-10'>
                <p className='text-white text-xl font-semibold tracking-wide'>
                    Cadastro realizado com sucesso!
                </p>

                <Icon id='Check' className='p-5 rounded-full bg-white text-[#f18844]' size={80} />

                <span className='max-w-[204px] text-white text-center font-medium tracking-wide'>
                    Atente-se ao seu e-mail para não perder nadinha!
                </span>
            </div>
        )
    }

    return (
        <div className='grid justify-center content-between gap-6 lg:gap-4'>
            {title && (
                <div
                    className='max-w-[436px] px-3.5 text-white text-center leading-tight font-bold tracking-wide [&_strong]:text-red-wine [&_strong]:font-extrabold'
                    dangerouslySetInnerHTML={{ __html: title }}
                />
            )}

            <form className='max-w-[436px] px-7 grid gap-3' onSubmit={handleSubscribe}>
                <div className='grid content-start gap-1 relative'>
                    <label className='text-white text-sm leading-4' htmlFor='name'>
                        Nome Completo
                    </label>

                    <input
                        id='name'
                        className='h-[42px] px-4 rounded text-sm placeholder:text-[#757575]'
                        type='text'
                        name='name'
                        placeholder='Nome completo'
                        onChange={removeErrorOnInput}
                    />

                    {isInvalid('name') && (
                        <span className='text-[#b3261e] text-sm font-semibold absolute top-0 right-0'>
                            {getErrorMessage('name')}
                        </span>
                    )}
                </div>

                <div className='grid content-start gap-1 relative'>
                    <label className='text-white text-sm leading-4' htmlFor='email'>
                        E-mail
                    </label>

                    <input
                        id='email'
                        className='h-[42px] px-4 rounded text-sm placeholder:text-[#757575]'
                        type='email'
                        name='email'
                        placeholder='Endereço de e-mail'
                        onChange={removeErrorOnInput}
                    />

                    {isInvalid('email') && (
                        <span className='text-[#b3261e] text-sm font-semibold absolute top-0 right-0'>
                            {getErrorMessage('email')}
                        </span>
                    )}
                </div>

                <div className='flex items-center gap-1.5'>
                    <input
                        id='terms'
                        className={`checkbox [--chkbg:140_37%_45%] w-[18px] h-[18px] bg-white checked:bg-success-600 ${
                            isInvalid('terms') ? 'border-red-wine' : 'border-transparent'
                        }`}
                        type='checkbox'
                        name='terms'
                        onChange={removeErrorOnInput}
                    />

                    <label
                        className={`text-xs leading-none ${
                            isInvalid('terms') ? 'text-red-wine' : 'text-white'
                        }`}
                        htmlFor='terms'
                    >
                        Ao enviar seus dados, você aceita nossa Política de Privacidade, além de
                        receber nossas ofertas de Black Friday.
                    </label>
                </div>

                <button className='h-[42px] rounded bg-red-wine text-white font-semibold tracking-wide'>
                    Cadastrar
                </button>

                {isInvalid('form') && (
                    <span className='text-[#b3261e] text-sm text-center font-semibold'>
                        {getErrorMessage('form')}
                    </span>
                )}
            </form>
        </div>
    )
}
